import "reflect-metadata";
import { Container, decorate, inject, injectable } from "inversify";

import "../version.js";
import { defineEngine } from "../framework/src/engine/pixi/bootPixiEngine";
import { defineSystem } from "../framework/src/system/defineSystem";
import { boot } from "../framework/src/boot/boot";
import Commander from "./Commander";
import SERVICE_IDENTIFIER from "../framework/src/constants/identifiers";
import { defineUI } from "../framework/src/ui/defineUI";
import { defineRegulation } from "../framework/src/regulations/defineRegulations";
import { defineSlotGame as defineGame } from "../framework/src/game/defineGame";
import IBootConfig from "../framework/src/boot/IBootConfig";
import InfoPages from "./InfoPages";
import initSettings from "../framework/src/settings/initSettings";
import { defineJokerWinBanner } from "./JokerWinBanner";
import IframeInfopages from "../framework/src/engine/IframeInfoPages";

let container = new Container();

decorate(injectable(), Commander);
decorate(inject(SERVICE_IDENTIFIER.System), Commander, 0);
decorate(inject(SERVICE_IDENTIFIER.Game), Commander, 1);
decorate(inject(SERVICE_IDENTIFIER.Engine), Commander, 2);
container.bind(SERVICE_IDENTIFIER.Commander).to(Commander).inSingletonScope();

const config: IBootConfig = {
	//@ts-ignore
	InfoPages: IframeInfopages,
};

export async function run(gameset) {
	defineSystem(gameset, container);
	defineEngine(container, config);
	defineGame(container);
	try {
		await initSettings(container);
	} catch (error) {
		return
	}
	defineUI(container);
	defineRegulation(container);
	defineJokerWinBanner(container);
	boot(container);
}